var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.926,
    height: 31.927,
    viewBox: "0 0 31.926 31.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard_icon",
    "data-name": "dashboard icon",
    d: "M17.483,31.927a.817.817,0,0,1-.76-.76V21.284a.76.76,0,0,1,.76-.76H31.166a.817.817,0,0,1,.76.76v9.882a.76.76,0,0,1-.76.76Zm-16.723,0a.817.817,0,0,1-.76-.76V13.682a.76.76,0,0,1,.76-.76H14.443a.817.817,0,0,1,.76.76V31.166a.76.76,0,0,1-.76.76ZM17.483,19a.817.817,0,0,1-.76-.76V.76a.76.76,0,0,1,.76-.76H31.166a.817.817,0,0,1,.76.76V18.243a.76.76,0,0,1-.76.76ZM.76,11.4a.817.817,0,0,1-.76-.76V.76A.76.76,0,0,1,.76,0H14.443a.817.817,0,0,1,.76.76v9.882a.76.76,0,0,1-.76.76Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.59f8a51e0d576af5ff79614936030528.svg";
export { ForwardRef as ReactComponent };